<template>
  <div>
    <filter-slot :filter="filters" :filter-principal="filterPrincipal" :total-rows="totalRows" :paginate="paginate"
      @reload="$refs['ref-table-users-list'].refresh()">
      <template #special-button>
        <feather-icon v-if="itemsSelected.length > 0" icon="CalendarIcon" size="20" variant="primary"
          class="cursor-pointer ml-2 text-primary" @click="openMultipleScheduleEmployeeModal(itemsSelected)"
          v-b-tooltip.hover :title="$t('Configure multiple schedules')" />
      </template>

      <template #table>
        <b-table selectable select-mode="multi" :per-page="paginate.perPage" no-select-on-click
          ref="ref-table-users-list" :current-page="paginate.currentPage" sticky-header="50vh" small show-empty
          no-provider-filtering class="position-relative font-small-3" responsive="sm" table-class="text-nowrap"
          :busy.sync="isBusy" :items="myProvider" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
          primary-key="id" :empty-text="$t('No matching records found')">
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-1" />
              <strong v-t="'Loading...'"></strong>
            </div>
          </template>
          <!-- 
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true">&check;</span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true">&nbsp;</span>
              <span class="sr-only">Not selected</span>
            </template>
          </template> -->
          <template #head(selected)="data">
            <b-form-checkbox @change="selectAll(data)" v-model="selectedAll"></b-form-checkbox>
          </template>

          <template #cell(selected)="data">
            <b-form-checkbox v-if="data.item.personal_type === 'Employee'"
              @change="checked(data.index, data.item.rowSelected)" v-model="data.item.rowSelected">
            </b-form-checkbox>
          </template>

          <template #cell(full_name)="data">
            <div class="d-flex">
              <div class="pt-1">
                <feather-icon v-if="data.item.personal_type == 'Driver'" icon="TruckIcon" size="22"
                  class="text-warning" />
                <feather-icon v-else icon="UserIcon" size="22" class="text-success" />
              </div>
              <div class="ml-1">
                <router-link target="_blank" :class="[textLink]" :to="{
                  name: 'rrhh-employees-information',
                  params: { id: data.item.id },
                }">
                  {{ data.item.full_name | capitalize }}
                </router-link>
                <br />
                <span style="opacity: 0.5">
                  #{{ data.item.personal_code }}
                </span>
                <br />
                <span style="opacity: 0.5">
                  DNI: {{ data.item.document_number }}
                </span>
                <br />
                <span style="opacity: 0.5" v-if="data.item.cell_phone">
                  TEL: {{ data.item.cell_phone }}
                </span>
                <!-- <br />
                <span
                  style="opacity: 0.5"
                  v-if="data.item.license_number"
                  :title="$t('License Number')"
                >
                  LIC: {{ data.item.license_number }}
                </span> -->
                <br />
                <span style="opacity: 0.5" v-if="data.item.start_date" :title="$t('Start Date')">
                  FI: {{ data.item.start_date }}
                </span>

              </div>
            </div>
          </template>
          <template #cell(area)="data">
            <span>{{ data.value | capitalize }}</span>
          </template>
          <template #cell(personal_type)="data">
            <span>{{ $t(data.value) | capitalize }}</span>
          </template>

          <template #cell(email)="data">
            <span> {{ data.item.email }} </span>
          </template>
          <template #cell(type)="data">
            <span> {{ $t(data.item.type) }} </span> <br />
          </template>
          <template #cell(campus)="data">
            <div class="row align-items-center">
              <span>{{ data.item.campus }}</span>
            </div>
          </template>
          <template #cell(vacations)="data">
            <span class="text-primary cursor-pointer" :title="$t('accumulated vacations')"
              v-if="data.item.vacations > 0" @click="openVacationsDetail(data.item.id)">{{ data.item.vacations }}</span>
            <span v-else>{{ data.item.vacations }}</span>
          </template>
          <template #cell(schedule_id)="data">
            <b-badge :variant="data.item.schedule_id != null ? 'light-primary' : 'light-danger'
              ">
              {{
                data.item.schedule_id != null
                  ? $t("Configured")
                  : $t("Not configured")
              }}
            </b-badge>
          </template>
          <template #cell(is_ceo)="data">
            <span> {{ data.item.is_ceo ? $t("Yes") : "No" }} </span>
          </template>
          <template #cell(start_date)="data">
            <span>
              {{ data.item.start_date == null ? "-" : data.item.start_date }}
            </span>
          </template>

          <template #cell(sunday)="data">
            <b-row v-for="(schedule, index) in JSON.parse(data.item.schedule)" :key="index">
              <b-col>
                <b-badge :variant="schedule.start_sunday == null
                  ? 'light-info'
                  : 'light-primary'
                  ">
                  {{
                    schedule.start_sunday == null ? "-" : schedule.start_sunday
                  }}
                </b-badge>
              </b-col>
              <b-col class="mt-1">
                <b-badge :variant="schedule.end_sunday == null ? 'light-info' : 'light-primary'
                  ">
                  {{ schedule.end_sunday == null ? "-" : schedule.end_sunday }}
                </b-badge>
              </b-col>
            </b-row>
          </template>

          <template #cell(monday)="data">
            <b-row v-for="(schedule, index) in JSON.parse(data.item.schedule)" :key="index">
              <b-col>
                <b-badge :variant="schedule.start_monday == null
                  ? 'light-info'
                  : 'light-primary'
                  ">
                  {{
                    schedule.start_monday == null ? "-" : schedule.start_monday
                  }}
                </b-badge>
              </b-col>
              <b-col class="mt-1">
                <b-badge :variant="schedule.end_monday == null ? 'light-info' : 'light-primary'
                  ">
                  {{ schedule.end_monday == null ? "-" : schedule.end_monday }}
                </b-badge>
              </b-col>
            </b-row>
          </template>

          <template #cell(tuesday)="data">
            <b-row v-for="(schedule, index) in JSON.parse(data.item.schedule)" :key="index">
              <b-col>
                <b-badge :variant="schedule.start_tuesday == null
                  ? 'light-info'
                  : 'light-primary'
                  ">
                  {{
                    schedule.start_tuesday == null
                      ? "-"
                      : schedule.start_tuesday
                  }}
                </b-badge>
              </b-col>
              <b-col class="mt-1">
                <b-badge :variant="schedule.end_tuesday == null
                  ? 'light-info'
                  : 'light-primary'
                  ">
                  {{
                    schedule.end_tuesday == null ? "-" : schedule.end_tuesday
                  }}
                </b-badge>
              </b-col>
            </b-row>
          </template>

          <template #cell(wednesday)="data">
            <b-row v-for="(schedule, index) in JSON.parse(data.item.schedule)" :key="index">
              <b-col>
                <b-badge :variant="schedule.start_wednesday == null
                  ? 'light-info'
                  : 'light-primary'
                  ">
                  {{
                    schedule.start_wednesday == null
                      ? "-"
                      : schedule.start_wednesday
                  }}
                </b-badge>
              </b-col>
              <b-col class="mt-1">
                <b-badge :variant="schedule.end_wednesday == null
                  ? 'light-info'
                  : 'light-primary'
                  ">
                  {{
                    schedule.end_wednesday == null
                      ? "-"
                      : schedule.end_wednesday
                  }}
                </b-badge>
              </b-col>
            </b-row>
          </template>

          <template #cell(thursday)="data">
            <b-row v-for="(schedule, index) in JSON.parse(data.item.schedule)" :key="index">
              <b-col>
                <b-badge :variant="schedule.start_thursday == null
                  ? 'light-info'
                  : 'light-primary'
                  ">
                  {{
                    schedule.start_thursday == null
                      ? "-"
                      : schedule.start_thursday
                  }}
                </b-badge>
              </b-col>
              <b-col class="mt-1">
                <b-badge :variant="schedule.end_thursday == null
                  ? 'light-info'
                  : 'light-primary'
                  ">
                  {{
                    schedule.end_thursday == null ? "-" : schedule.end_thursday
                  }}
                </b-badge>
              </b-col>
            </b-row>
          </template>

          <template #cell(friday)="data">
            <b-row v-for="(schedule, index) in JSON.parse(data.item.schedule)" :key="index">
              <b-col>
                <b-badge :variant="schedule.start_friday == null
                  ? 'light-info'
                  : 'light-primary'
                  ">
                  {{
                    schedule.start_friday == null ? "-" : schedule.start_friday
                  }}
                </b-badge>
              </b-col>
              <b-col class="mt-1">
                <b-badge :variant="schedule.end_friday == null ? 'light-info' : 'light-primary'
                  ">
                  {{ schedule.end_friday == null ? "-" : schedule.end_friday }}
                </b-badge>
              </b-col>
            </b-row>
          </template>

          <template #cell(saturday)="data">
            <b-row v-for="(schedule, index) in JSON.parse(data.item.schedule)" :key="index">
              <b-col>
                <b-badge :variant="schedule.start_saturday == null
                  ? 'light-info'
                  : 'light-primary'
                  ">
                  {{
                    schedule.start_saturday == null
                      ? "-"
                      : schedule.start_saturday
                  }}
                </b-badge>
              </b-col>
              <b-col class="mt-1">
                <b-badge :variant="schedule.end_saturday == null
                  ? 'light-info'
                  : 'light-primary'
                  ">
                  {{
                    schedule.end_saturday == null ? "-" : schedule.end_saturday
                  }}
                </b-badge>
              </b-col>
            </b-row>
          </template>

          <template #cell(status)="data">
            <b-badge pill :variant="data.item.status == 'Active' ? 'light-success' : 'light-warning'
              " class="text-capitalize">
              <span> {{ $t(data.item.status) | capitalize }}</span>
            </b-badge>
          </template>

          <template #cell(fecha_cese)="data">
            <div v-if="data.item.fecha_cese != null" class="d-flex flex-column">
              <span class="text-danger">
                Fecha de Cese:
                {{ data.item.fecha_cese | prettyDateWithoutTime}}
              </span>
              <span class="text-danger">
                Responsable:
                {{ data.item.cesado_por }}
              </span>
            </div>
            <b-badge :variant="''" v-else>
              <span>No Cesado</span>
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" no-caret
                :menu-class="'py-0 my-0'" dropleft>
                <template #button-content>
                  <feather-icon icon="MoreVerticalIcon" size="16" class="text-primary cursor-pointer" />
                </template>

                <b-dropdown-item v-if="data.item.personal_type === 'Employee'"
                  @click="openScheduleEmployeeModal(data.item.id)" class="d-flex align-items-end w-100"
                  :link-class="'w-100'">
                  <feather-icon icon="CalendarIcon" size="16" class="text-primary me-2 mr-05"
                    style="margin-bottom: 2px" />
                  <span style="line-height: 16px">{{
                    $t("View Schedule")
                  }}</span>
                </b-dropdown-item>

                <b-dropdown-item v-if="!data.item.fecha_cese"
                  @click="openCesarEmpleadoModal(data.item)" class="d-flex align-items-end w-100" :link-class="'w-100'">
                  <feather-icon icon="UserXIcon" size="16" class="text-info me-2 mr-05" style="margin-bottom: 2px" />
                  <span style="line-height: 16px">Cesar empleado</span>
                </b-dropdown-item>

                <b-dropdown-item v-if="data.item.fecha_cese && data.item.tiene_liquidacion_pendiente" @click="anularCeseEmpleado(data.item)"
                  class="d-flex align-items-end w-100" :link-class="'w-100'">
                  <feather-icon icon="CornerUpLeftIcon" size="16" class="text-warning me-2 mr-05"
                    style="margin-bottom: 2px" />
                  <span style="line-height: 16px">Anular cese</span>
                </b-dropdown-item>

                <b-dropdown-item v-if="
                  data.item.personal_type != 'Driver' &&
                  data.item.personal_type != 'Stevedore'
                " class="d-flex align-items-end w-100" :link-class="'w-100'" @click="downloadQR(data.item.id)">
                  <QrIcon class="text-primary me-2 mr-05" style="margin-bottom: 2px" />

                  <span style="line-height: 16px"> Descargar QR </span>
                </b-dropdown-item>

                <b-dropdown-item @click="openModalHistorialAumento(data.item)" class="d-flex align-items-end w-100"
                  :link-class="'w-100'">
                  <feather-icon icon="ListIcon" size="16" class="text-primary me-2 mr-05" style="margin-bottom: 2px" />
                  <span style="line-height: 16px">Historial de aumento</span>
                </b-dropdown-item>

                <b-dropdown-item @click="openModalHistorialLiquidaciones(data.item)"
                  class="d-flex align-items-end w-100" :link-class="'w-100'">
                  <feather-icon icon="FileTextIcon" size="16" class="text-primary me-2 mr-05"
                    style="margin-bottom: 2px" />
                  <span style="line-height: 16px">Historial de liquidaciones</span>
                </b-dropdown-item>

                <b-dropdown-item v-if="data.item.status == 'Active'" @click="deleteEmployee(data.item.id)"
                  class="d-flex align-items-end w-100" :link-class="'w-100'">
                  <feather-icon icon="TrashIcon" size="16" class="text-danger me-2 mr-05" style="margin-bottom: 2px" />
                  <span style="line-height: 16px">Desactivar</span>
                </b-dropdown-item>

                <b-dropdown-item v-if="data.item.status != 'Active'" @click="activeEmployee(data.item.id)"
                  class="d-flex align-items-end w-100" :link-class="'w-100'">
                  <feather-icon icon="CheckIcon" size="16" class="text-success me-2 mr-05" style="margin-bottom: 2px" />
                  <span style="line-height: 16px">Activar</span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>

        <b-modal hide-footer size="xl" no-close-on-backdrop no-close-on-esc v-model="showEmployeeScheduleModal"
          :title="$t('Employee Schedule')">
          <PersonalSchedule :employeeId="employeeId" :type="'modal'" @close="showEmployeeScheduleModal = false"
            @refreshTable="$refs['ref-table-users-list'].refresh()" />
        </b-modal>

        <MultiplePersonalSchedule v-if="showMultipleEmployeeScheduleModal" :employeeIds="employeeIds"
          @updated="closeMultipleScheduleEmployeeModalWithRefresh" @close="closeMultipleScheduleEmployeeModal" />

        <VacationsDetailModal v-if="showVacationsDetail" :employeeId="employeeId"
          @close="showVacationsDetail = false" />

        <HistorialAumentoModal v-if="showHistorialAumento" :modalData="dataModalAumento"
          @close="showHistorialAumento = false" />

        <CesarEmpleadoModal v-if="showCesarEmpleadoModal" :modalData="dataModalCesarEmpleado"
          @close="showCesarEmpleadoModal = false" @saved="handleSaveCesarEmpleado" />

        <HistorialLiquidacionesModal v-if="showHistorialLiquidaciones" :modalData="dataModalLiquidaciones"
          @close="showHistorialLiquidaciones = false" />
      </template>
    </filter-slot>
  </div>
</template>

<script>
/* DATA */
import Fields from "@/views/rrhh/views/employees/data/Fields.data";
import Filters from "@/views/rrhh/views/employees/data/Filters.data";

/* COMPONENTS */
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import EmployeeServices from "@/views/rrhh/views/employees/services/employee.service";
import PersonalSchedule from "@/views/rrhh/views/employees/components/information/schedule/PersonalSchedule.vue";
import MultiplePersonalSchedule from "@/views/rrhh/views/employees/components/information/schedule/MultiplePersonalSchedule.vue";
import { mapGetters } from "vuex";
import VacationsDetailModal from "@/views/rrhh/views/employees/components/modal/VacationsDetailModal.vue";

import HistorialAumentoModal from "@/views/rrhh/views/employees/components/modal/HistorialAumentoModal.vue";
import CesarEmpleadoModal from "@/views/rrhh/views/employees/components/modal/CesarEmpleadoModal.vue";
import UserService from "@/views/users/services/users.service.js";
import QrIcon from "@/icons/QrIcon.vue";
import HistorialLiquidacionesModal from "@/views/rrhh/views/employees/components/modal/HistorialLiquidacionesModal.vue";

export default {
  components: {
    FilterSlot,
    HistorialAumentoModal,
    PersonalSchedule,
    MultiplePersonalSchedule,
    VacationsDetailModal,
    CesarEmpleadoModal,
    QrIcon,
    HistorialLiquidacionesModal
  },
  data() {
    return {
      selectedAll: false,
      startPage: 0,
      filters: Filters,
      toPage: 0,
      isBusy: false,
      sortBy: "",
      sortDesc: false,
      totalRows: 0,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        currentPage: 1,
        perPage: 10,
        perPageOptions: [10, 20, 30, 40, 50, 100],
      },
      dataModalAumento: null,
      dataMeta: {
        from: 0,
        to: 0,
        of: 0,
      },
      showHistorialAumento: false,
      showEmployeeScheduleModal: false,
      showMultipleEmployeeScheduleModal: false,
      employeeId: null,
      employeeIds: [],
      tableData: [],
      itemsSelected: [],
      showVacationsDetail: false,
      dataModalCesarEmpleado: null,
      showCesarEmpleadoModal: false,
      dataModalLiquidaciones: null,
      showHistorialLiquidaciones: false,
    };
  },
  created() {
    this.filters[4].model = 1;
    this.getAllAreas();
  },
  methods: {
    handleSaveCesarEmpleado() {
      this.showCesarEmpleadoModal = false;
      this.refreshTable();
    },
    async downloadQR(userId) {
      try {
        this.addPreloader();
        const data = await UserService.downloadQr({ user_id: userId });
        await this.forceFileDownloadPdf(data, "blank");
      } catch (e) {
        if (e.response && e.response.data) {
          try {
            const text = await e.response.data.text();
            const json = JSON.parse(text);
            this.showToastError(
              json.message || this.$t("error downloading qr")
            );
          } catch {
            this.showToastError(this.$t("error downloading qr"));
          }
        } else {
          this.showToastError(this.$t("error downloading qr"));
        }
      } finally {
        this.removePreloader();
      }
    },
    openScheduleEmployeeModal(employeeId) {
      this.employeeId = employeeId;
      this.showEmployeeScheduleModal = true;
    },
    openModalHistorialAumento(item) {
      this.dataModalAumento = item;
      this.showHistorialAumento = true;
    },
    openModalHistorialLiquidaciones(item) {
      this.dataModalLiquidaciones = item;
      this.showHistorialLiquidaciones = true;
    },
    openCesarEmpleadoModal(item) {
      this.dataModalCesarEmpleado = item;
      this.showCesarEmpleadoModal = true;
    },
    async anularCeseEmpleado(item) {
      try {
        const { isConfirmed } = await this.showConfirmSwal(
          "¿Estás seguro de anular el cese de este empleado?"
        );
        if (!isConfirmed) return;

        this.addPreloader();
        const { data } = await EmployeeServices.anularCese({
          empleado_id: item.id,
        });
        this.showToastSuccess(data.message);
        this.refreshTable();
      } catch (error) {
        console.log(error);
        this.showToastError(error?.response?.data);
      } finally {
        this.removePreloader();
      }
    },
    selectAll(data) {
      let tableRef = this.$refs["ref-table-users-list"];

      if (this.selectedAll === true) {
        this.tableData.forEach((element, index) => {
          if (element.personal_type === "Employee") {
            tableRef.selectRow(index);
            this.tableData[index].rowSelected = true;
            this.itemsSelected.push(element.id);
          }
        });
      } else {
        this.tableData.forEach((element, index) => {
          if (element.personal_type === "Employee") {
            tableRef.unselectRow(index);
            this.tableData[index].rowSelected = false;
          }
        });
        this.itemsSelected = [];
      }
    },

    openMultipleScheduleEmployeeModal(employeeIds) {
      this.showMultipleEmployeeScheduleModal = true;
      this.employeeIds = employeeIds;
    },
    closeMultipleScheduleEmployeeModal() {
      this.showMultipleEmployeeScheduleModal = false;
    },

    closeMultipleScheduleEmployeeModalWithRefresh() {
      this.showMultipleEmployeeScheduleModal = false;
      let tableRef = this.$refs["ref-table-users-list"];
      tableRef.clearSelected();
      this.tableData.forEach((element) => {
        element.rowSelected = false;
      });
      this.selectedAll = false;
      this.refreshTable();
    },

    checked(index, checked) {
      let tableRef = this.$refs["ref-table-users-list"];

      if (this.tableData[index].personal_type === "Employee") {
        if (checked == false) {
          tableRef.unselectRow(index);
          this.tableData[index].rowSelected = false;
          this.itemsSelected = this.itemsSelected.filter(
            (item) => item != this.tableData[index].id
          );
        } else {
          tableRef.selectRow(index);
          this.tableData[index].rowSelected = true;
          this.itemsSelected.push(this.tableData[index].id);
        }
      }
    },
    async myProvider(ctx) {
      try {
        let order = 2;
        switch (ctx.sortBy) {
          case "personal_type":
            order = 4;
            break;
          case "area":
            order = 13;
            break;
          // case "personal_code":
          //   order = 5;
          //   break;
          // case "document_number":
          //   order = 6;
          //   break;
          case "group_entity":
            order = 10;
            break;
          case "status":
            order = 8;
            break;
          case "vacations":
            order = 15;
            break;
          default:
            order = 2;
            break;
        }
        let params = {
          from: this.filters[0].model,
          to: this.filters[1].model,
          personalType: this.filters[2].model,
          entityGroup: this.filters[3].model,
          npage: ctx.currentPage,
          perpage: ctx.perPage,
          name_text: this.filterPrincipal.model,
          orderby: ctx.sortDesc ? "desc" : "asc",
          order: order,
          status: this.filters[4].model ?? 1,
          area_id: this.filters[5].model ?? null,
        };
        const { data } = await EmployeeServices.getEmployees(params);
        this.paginate.currentPage = data.current_page;
        this.paginate.perPage = data.per_page;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.from = data.from;

        this.tableData = data.data;

        return data.data || [];
      } catch (error) {
        console.log(error);
        return [];
      }
    },

    refreshTable() {
      this.$refs["ref-table-users-list"].refresh();
    },

    async getAllAreas() {
      try {
        const { data } = await EmployeeServices.getAllAreas({
          moduleId: this.currentUser.modul_id,
        });
        this.filters[5].options = data;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteEmployee(employeeId) {
      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;
      try {
        this.addPreloader();
        const { data } = await EmployeeServices.inactiveEmployeeById({
          id: employeeId,
        });
        this.showToastSuccess("Success", "Employee inactivated");
        this.refreshTable();
      } catch (error) {
        console.log(error);
        this.showToastError(error?.response?.data);
      } finally {
        this.removePreloader();
      }
    },

    async activeEmployee(employeeId) {
      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;
      try {
        this.addPreloader();
        const { data } = await EmployeeServices.activeEmployeeById({
          id: employeeId,
        });
        this.showToastSuccess("Success", "Empleado activado");
        this.refreshTable();
      } catch (error) {
        console.log(error);
        this.showToastError(error?.response?.data);
      } finally {
        this.removePreloader();
      }
    },

    async openVacationsDetail(employeeId) {
      this.showVacationsDetail = true;
      this.employeeId = employeeId;
    },
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    fields() {
      return Fields.filter((element) => element.visible);
    },
  },
};
</script>

<style>
.dark-layout .table.b-table>tbody .b-table-row-selected.table-active td {
  background-color: #424141 !important;
}

.mw {
  min-width: 50px !important;
}

.mr-05 {
  margin-right: 0.5rem !important;
}
</style>